import React, { useEffect, useState } from "react";
import "./CSS/Header.css";
import tringle from "../Assets/Triangle-Exclamation-Point.png";
import alert from "../Assets/2014825.png";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LeftPart from "./LeftPart";
import NotificationsIcon from "../Assets/Icons/Notifications.png";
import { set_notis_last, set_external_trend_info, set_alarms_action, alarm_popup_control_func } from "../Action/Action";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import axiosInstance from "../services/axiosConfig";

import {
  CLEAR_COMPANY_ID,
  clear_email,
  clear_uid,
  set_system_moni_control,
  set_username,
  setTesis,
} from "../Action/Action";

const Header = (props) => {
  const domain_current = useSelector(
    (state) => state.project_reducer.current_domain
  );

  const [alert_, Set_alert] = useState(null);

  const [bodywidth, setbodywidth] = useState(window.innerWidth);

  const [alarm_okuma, Set_alarm_okuma] = useState(false)

  useEffect(() => {
    if (props.yetkilendirme && props.ucer_id !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.uid];
      if (newObj !== undefined && newObj["Alarm"]!==undefined) {

        if (newObj["Alarm"]["O"] === "t") {

          Set_alarm_okuma(true)
        } else {
          Set_alarm_okuma(false);

        }
      }

    }
  }, [props.pages])


  useEffect(() => {
    const handleResize = () => {
      // Body elementine erişim sağlanıyor
      const body = document.body;

      // Body elementinin genişliği alınıyor
      const bodyWidth = body.clientWidth;

      setbodywidth(bodyWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useEffect(() => {
    if (
      !props.alarms_popup_control &&
      props.alarms2 &&
      props.alarms2.length > 0
    ) {
      let newData = props.alarms;
      newData = newData.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      newData = newData.filter(i => {
        return i.confirm_ === 0
      })
      let newData2 = props.alarms2;
      newData2 = newData2.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      newData2 = newData2.filter(i => {
        return i.confirm_ === 0
      })
      if (JSON.stringify(newData[newData.length - 1] !== JSON.stringify(newData2[newData2.length - 1])) && newData.length > 0 && newData2.length > 0) {

        let msg = newData2[0].message ?? "";
        let type = "err"

        let new_obj = { message: msg, type: type, tagName: newData2[0].tagName };
        Set_alert(new_obj);
        Store.dispatch(set_notis_last(props.alarms[0].tagId));
        Store.dispatch(set_alarms_action(props.alarms2))
        Store.dispatch(alarm_popup_control_func(true))
      }

    }
  }, [props.alarms]);

  useEffect(() => {
    if (alert_ !== null) {
      setTimeout(() => {
        Set_alert(null);
      }, 6000);
    }
  }, [alert_]);

  const daysOfWeek = [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi",
  ];

  const [username_, Setusername_] = useState("");

  const history = useHistory();

  useEffect(() => {
    Setusername_(props.username);
  }, []);

  const [currentHour, SetcurrentHour] = useState(null);
  const [currentMinute, SetcurrentMinute] = useState(null);
  const [currentDay, SetcurrentDay] = useState(null);
  const [currentDay2, SetcurrentDay2] = useState(null);
  const [currentyear, Setcurrentyear] = useState(null);
  const [currentmonth, Setcurrentmonth] = useState(null);

  // Clock update with proper cleanup
  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      SetcurrentHour(now.getHours());
      SetcurrentMinute(now.getMinutes());
      SetcurrentDay(now.getDate());
      Setcurrentmonth(now.getMonth());
      Setcurrentyear(now.getFullYear());
      SetcurrentDay2(daysOfWeek[now.getDay()]);
    };

    updateClock(); // Initial update
    const interval = setInterval(updateClock, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const hamburger_click = (e) => {
    document.querySelector(".hamburger").classList.toggle("hamburger_active");
    document.querySelector(".left_menu").classList.toggle("left_menu_active");
  };

  const [dis_hava_nem, Set_dis_hava_nem] = useState(null);
  const [dis_hava_sic, Set_dis_hava_sic] = useState(null);

  useEffect(() => {
    const componentDidMount = async () => {

      if (props.tag_list.length > 0) {
        var fetch_obj = [

        ];
        var dishavaObj = {
          "nem": "",
          "sicaklik": ""
        }

        // Company bazlı sabit tag ID'leri (öncelik)
        const companyWeatherTags = {
          1: { sicaklik: null, nem: null }, // Pattern matching kullanacak
          3: { sicaklik: 11445, nem: 11444 }, // Sabit ID'ler
        }

        const companyId = props.temp_com_id
        const fixedTags = companyWeatherTags[companyId]

        // Eğer company için sabit ID varsa, direkt kullan
        if (fixedTags?.sicaklik) {
          dishavaObj.sicaklik = fixedTags.sicaklik
          fetch_obj.push({ tagId: `${fixedTags.sicaklik}` })
        }
        if (fixedTags?.nem) {
          dishavaObj.nem = fixedTags.nem
          fetch_obj.push({ tagId: `${fixedTags.nem}` })
        }

        // Pattern matching ile tag ara (sadece sabit ID yoksa)
        if (!dishavaObj.sicaklik || !dishavaObj.nem) {
          props.tag_list.forEach(a => {
            const tagNameLower = a.tagName.toLowerCase()

            // Dış hava sıcaklık: İngilizce ve Türkçe karakterleri destekle
            const isSicaklik =
              // İngilizce versiyonlar (alt çizgili)
              tagNameLower.includes("dishava_sic") ||
              tagNameLower.includes("dis_hava_sic") ||
              tagNameLower.includes("dishava_sicaklik") ||
              tagNameLower.includes("dis_hava_sicaklik") ||
              // Türkçe versiyonlar (boşluklu ve Türkçe karakterli)
              tagNameLower.includes("dış hava sıcak") ||
              tagNameLower.includes("dışhava sıcak") ||
              tagNameLower.includes("dış_hava_sıcak") ||
              tagNameLower.includes("dışsıcaklık") ||
              // Tam eşleşme
              (tagNameLower.includes("dış") && tagNameLower.includes("hava") && tagNameLower.includes("sıcak"))

            const isNem =
              tagNameLower.includes("dishava_nem") ||
              tagNameLower.includes("dis_hava_nem") ||
              tagNameLower.includes("dış hava nem") ||
              tagNameLower.includes("dışhava nem") ||
              tagNameLower.includes("dış_hava_nem")

            if (isSicaklik && !dishavaObj.sicaklik) {
              fetch_obj.push({ tagId: `${a.tagId}` })
              dishavaObj.sicaklik = a.tagId
            } else if (isNem && !dishavaObj.nem) {
              fetch_obj.push({ tagId: `${a.tagId}` })
              dishavaObj.nem = a.tagId
            }

          })
        }

        const req = await axiosInstance.post("/tags/GetTagValues", fetch_obj);
        const response = req.data;

        if (req.status === 200) {
          var newdata = response;
          newdata.forEach((item, index) => {
            // Tip uyumsuzluğu için String karşılaştırması
            if (String(item.tagId) === String(dishavaObj.sicaklik)) {
              var değer = item.tagValue;
              // Sadece sayısal kısmı al (°C, %, vb. birimleri temizle)
              değer = değer.replace(/[^0-9.,\-]/g, ''); // Sadece rakam, virgül, nokta, eksi
              değer = değer.replaceAll(",", ".");
              değer = Number(değer).toFixed(2);
              değer = String(değer) + " °C";
              Set_dis_hava_sic(değer);
            } else if (String(item.tagId) === String(dishavaObj.nem)) {
              var değer = item.tagValue;
              // Sadece sayısal kısmı al (°C, %, vb. birimleri temizle)
              değer = değer.replace(/[^0-9.,\-]/g, ''); // Sadece rakam, virgül, nokta, eksi
              değer = değer.replaceAll(",", ".");
              değer = Number(değer).toFixed(2);
              değer = String(değer) + "%";

              Set_dis_hava_nem(değer);
            }
          });
        }
      };
    }
    componentDidMount();
  }, [props.tag_list]);

  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      // Sadece dün (yesterday only - same start and end)
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: yesterdayFormatted,  // Aynı gün (sadece dün)
        trendType: 'daily'
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      // day_trend error
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      // Ayın başından bugüne
      let monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

      let todayFormatted = formatDate(today);
      let monthStartFormatted = formatDate(monthStart);

      let newObj = {
        inital_date: monthStartFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
        trendType: 'monthly'
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      // month_trend error
    }
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      // Yılın başından bugüne
      let yearStart = new Date(today.getFullYear(), 0, 1);

      let todayFormatted = formatDate(today);
      let yearStartFormatted = formatDate(yearStart);

      let newObj = {
        inital_date: yearStartFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
        trendType: 'yearly'
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      // year_trend error
    }
  };

  const [temp_width, Set_temp_width] = useState(0)

  useEffect(() => {
    setTimeout(() => {
      if (window.location.pathname === "/dynamicPage") {
        Set_temp_width(props.canvas_boyutu.width)
      } else {
        if (/^\/pages\/[^\/]+$/.test(window.location.pathname)) {
          Set_temp_width(props.canvas_boyutu.width)
        } else {
          if (/^\/pages\/[^\/]+(\/edit)?$/.test(window.location.pathname)) {
            Set_temp_width(props.canvas_boyutu.width)

          } else if (/^\/template_management\/[^\/]+(\/edit)?$/.test(window.location.pathname)
          ) {
            Set_temp_width(props.canvas_boyutu.width)
          }
        }
      }
    }, 200);


  }, [window.location.pathname])

  useEffect(() => {
    setTimeout(() => {
      if (window.location.pathname === "/dynamicPage") {
        Set_temp_width(props.canvas_boyutu.width)
      } else {
        if (/^\/pages\/[^\/]+$/.test(window.location.pathname)) {
          Set_temp_width(props.canvas_boyutu.width)
        } else {
          if (/^\/pages\/[^\/]+(\/edit)?$/.test(window.location.pathname)) {
            Set_temp_width(props.canvas_boyutu.width);

          } else if (/^\/template_management\/[^\/]+(\/edit)?$/.test(window.location.pathname)
          ) {
            Set_temp_width(props.canvas_boyutu.width)
          }
        }
      }
    }, 1000);


  }, [props.canvas_boyutu])


  const [alarm_list, SetAlarm_List] = useState([])
  const [noti_list, SetNoti_list] = useState([])
  const [loading, SetLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      const ComponentDidMount = async () => {
        try {
          const request = await axiosInstance.post("/tags/GetAlarmList", {
            companyId: props.ucer_id,
          });
          const response = request.data;
          let newData = [];
          newData = response.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
          newData = newData.filter(i => {
            return i.confirm_ === 0
          })
          SetNoti_list(newData);
        } catch (err) {
          SetLoading(true);
        }
      };
      ComponentDidMount();
    }, 80);
  }, []);



  useEffect(() => {
    setTimeout(() => {
      const componentDidMount = async () => {
        try {

          const request = await axiosInstance.post("/tags/GetAlarmList", {
            "companyId": props.ucer_id
          });

          if (request.status === 200) {
            SetAlarm_List(request.data)
          }

          SetLoading(false)

        } catch (err) {
          SetLoading(true)

        }
      }
      componentDidMount()
    }, 80)

  }, [])


  return (
    <>
      <div className="left_menu">
        <LeftPart />
      </div>
      <header style={{ width: "100%" }} >
        <nav>
          <div className="show_pop_up show_external_trend">
            <i
              onClick={close_pop_up}
              style={{ position: "relative", left: "50%" }}
              className="fa fa-times close_tag_pop_up"
            ></i>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
              className="top_flex"
            >
              <p>
                {" "}
                TagId:{" "}
                <span className="pop_up_x pop_up_external show_tagId"></span>
              </p>
              <p>
                {" "}
                TagName:{" "}
                <span className="pop_up_x pop_up_external show_tagName"></span>
              </p>
            </div>
            <div className="btn_area_popup_external">
              <button
                onClick={(e) => {
                  day_trend(e);
                }}
              >
                Günlük Trend <i className="fa-solid fa-chart-line"></i>
              </button>
              <button
                onClick={(e) => {
                  month_trend(e);
                }}
              >
                Aylık Trend <i className="fa-solid fa-chart-line"></i>
              </button>
              <button
                onClick={(e) => {
                  year_trend(e);
                }}
              >
                Yıllık Trend <i className="fa-solid fa-chart-line"></i>
              </button>
            </div>
          </div>
          <div className="show_pop_up show_external_trend">
            <i
              onClick={close_pop_up}
              style={{ position: "relative", left: "50%" }}
              className="fa fa-times close_tag_pop_up"
            ></i>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
              className="top_flex"
            >
              <p>
                {" "}
                TagId:{" "}
                <span className="pop_up_x pop_up_external show_tagId"></span>
              </p>
              <p>
                {" "}
                TagName:{" "}
                <span className="pop_up_x pop_up_external show_tagName"></span>
              </p>
            </div>
            <div className="btn_area_popup_external">
              <button
                onClick={(e) => {
                  day_trend(e);
                }}
              >
                Günlük Trend <i className="fa-solid fa-chart-line"></i>
              </button>
              <button
                onClick={(e) => {
                  month_trend(e);
                }}
              >
                Aylık Trend <i className="fa-solid fa-chart-line"></i>
              </button>
              <button
                onClick={(e) => {
                  year_trend(e);
                }}
              >
                Yıllık Trend <i className="fa-solid fa-chart-line"></i>
              </button>
            </div>
          </div>
          <div onClick={hamburger_click} className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="nav-left-part">
            {/* Company bazlı logo gösterimi - dinamik URL */}
            {props.company_logo_url && (
              <img src={props.company_logo_url} alt="Company Logo" className="akralogo" />
            )}
            <div className="middle_info_part_fans">
              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  const { clientX, clientY } = e;
                  var tagName = props.tag_list
                    .filter((b) => b.tagId === "157")
                    .map((c) => c.tagName)[0];

                  document.querySelector(".show_tagName").innerHTML = tagName;

                  document
                    .querySelector(".show_external_trend")
                    .classList.toggle("show_external_trend_active");
                  document.querySelector(".show_tagId").innerHTML = "157";
                  var popup = document.querySelector(".show_external_trend");
                  const popupRect = popup.getBoundingClientRect();
                  const viewportWidth = window.innerWidth;
                  const viewportHeight = window.innerHeight;

                  // Calculate the new positions
                  let newX = clientX;
                  let newY = clientY;

                  // Adjust if the popup would overflow the right edge of the viewport
                  if (newX + popupRect.width > viewportWidth) {
                    newX = viewportWidth - popupRect.width;
                  }

                  // Adjust if the popup would overflow the bottom edge of the viewport
                  if (newY + popupRect.height > viewportHeight) {
                    newY = viewportHeight - popupRect.height;
                  }

                  // Adjust if the popup would overflow the left edge of the viewport
                  if (newX < 0) {
                    newX = 0;
                  }

                  // Adjust if the popup would overflow the top edge of the viewport
                  if (newY < 0) {
                    newY = 0;
                  }

                  // Set the position of the popup
                  popup.style.left = `${newX}px`;
                  popup.style.top = `${newY}px`;
                }}
                className="mid_names"
              >
                <p>Dış Hava Sıcaklık</p>
                <h5>{dis_hava_sic}</h5>
              </div>
              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  const { clientX, clientY } = e;
                  var tagName = props.tag_list
                    .filter((b) => b.tagId === "158")
                    .map((c) => c.tagName)[0];

                  document.querySelector(".show_tagName").innerHTML = tagName;

                  document
                    .querySelector(".show_external_trend")
                    .classList.toggle("show_external_trend_active");
                  document.querySelector(".show_tagId").innerHTML = "158";
                  var popup = document.querySelector(".show_external_trend");
                  const popupRect = popup.getBoundingClientRect();
                  const viewportWidth = window.innerWidth;
                  const viewportHeight = window.innerHeight;

                  // Calculate the new positions
                  let newX = clientX;
                  let newY = clientY;

                  // Adjust if the popup would overflow the right edge of the viewport
                  if (newX + popupRect.width > viewportWidth) {
                    newX = viewportWidth - popupRect.width;
                  }

                  // Adjust if the popup would overflow the bottom edge of the viewport
                  if (newY + popupRect.height > viewportHeight) {
                    newY = viewportHeight - popupRect.height;
                  }

                  // Adjust if the popup would overflow the left edge of the viewport
                  if (newX < 0) {
                    newX = 0;
                  }

                  // Adjust if the popup would overflow the top edge of the viewport
                  if (newY < 0) {
                    newY = 0;
                  }

                  // Set the position of the popup
                  popup.style.left = `${newX}px`;
                  popup.style.top = `${newY}px`;
                }}
                className="mid_names"
              >
                <p>Dış Hava Nem</p>
                <h5>{dis_hava_nem}</h5>
              </div>
            </div>
          </div>
          <div className="middlepart-nav">
            <div className="nav-time-part">
              {currentHour}:
              {currentMinute < 10 ? `0${currentMinute}` : currentMinute}
            </div>
            <div>
              <div style={{ marginLeft: "5%" }} className="date-part-nav">
                {currentDay < 10 ? `0${currentDay}` : currentDay}/
                {currentmonth + 1 < 10
                  ? `0${currentmonth + 1}`
                  : currentmonth + 1}
                /{currentyear}
              </div>
              <div className="day-part-nav">{currentDay2}</div>
            </div>
          </div>
          <div className="right-part-nav">
            <div
              id="header_right_part"
              style={{ display: "flex", position: "relative" }}
            >
              {/* {alert_ !== null && (
                <div
                  onClick={() => {
                    history.push("/Alarmpanel")
                  }}
                  id={
                    alert_.type === "err"
                      ? "red"
                      : alert_.type === "green"
                        ? "green"
                        : "yellow"
                  }
                  className="hidden_pop_up navbar-noti-pop"
                >
                  <p className="one_new_b">1 Yeni Alarm</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <p className="noti_message">
                      {alert_.message + "  " + `( ${alert_.tagName} )`}
                      <i id="noti_arrow" className="fa fa-arrow-right"></i>
                    </p>

                  </div>
                </div>
              )} */}


              <div>
                <img
                  onClick={() => {
                    if (alarm_okuma) history.push("/Alarmpanel")
                  }}
                  className={
                    alarm_list &&
                    (alarm_list.length > 1 ? "red_alarm_active" : "red_alarm")
                  }
                  src={alert}
                  alt=""
                />
              </div>
              <div className="user_profile_part">
                {props.profile_photo !== "" ? (
                  <img
                    onClick={() => {
                      history.push("/profile");
                    }}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "40px",
                    }}
                    src={props.profile_photo}
                    alt=""
                  />
                ) : (
                  <i
                    onClick={() => {
                      history.push("/profile");
                    }}
                    className="fa-solid fa-user fa-sm"
                  ></i>
                )}
                <p>{username_}</p>
              </div>
              <div className="log-out-header">
                <div
                  onClick={async () => {
                    await Store.dispatch(clear_uid());
                    await Store.dispatch(clear_email());
                    await Store.dispatch(set_username(""));
                    await Store.dispatch(CLEAR_COMPANY_ID());
                    sessionStorage.removeItem("user_id");
                    sessionStorage.removeItem("user_email");
                    sessionStorage.removeItem("username");
                    sessionStorage.removeItem("ucer_id");
                    sessionStorage.removeItem("Tesis");
                    sessionStorage.removeItem("TEMPCOM");
                    sessionStorage.removeItem("user_companyId");
                    window.location.href = "/";
                  }}
                  className="link-group-login-links"
                  style={{ cursor: "pointer" }}
                >
                  <i class="fa-sharp fa-solid fa-door-open "></i>
                  <span>Çıkış Yap</span>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    username: state.auth_reducer.username,
    uid: state.auth_reducer.user_id,
    alarms: state.project_reducer.alarms,
    alarms2: state.project_reducer.alarms2,
    pages: state.project_reducer.pages,
    notis: state.project_reducer.notifications,
    fans_tags: state.project_reducer.fans_tags,
    notis_last: state.project_reducer.notis_last_id,
    user_email: state.auth_reducer.email,
    profile_photo: state.project_reducer.profile_photo,
    tesis: state.project_reducer.tesis,
    tag_list: state.project_reducer.tag_list,
    canvas_boyutu: state.project_reducer.canvas_boyut_gecici,
    ucer_id: state.project_reducer.company_id,
    alarms_popup_control: state.project_reducer.alarm_popup_control,
    users_list: state.project_reducer.users_list,
    temp_com_id: state.project_reducer.temp_com_id,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    company_logo_url: state.project_reducer.company_logo_url,


  };
};

export default connect(MapStateToProps)(Header);
